<template>
  <div>
    <schedule-form></schedule-form>
    <job-forms></job-forms>
    <el-dialog
      v-if="createPacketShow"
      visible
      width="80%"
      :title="$t('packets.createAppsPacket')"
      @close="cancelCreatePacket"
      :close-on-click-modal="false"
    >
      <el-form
        :rules="packetCreationRules"
        :model="packetCreation"
        ref="packetCreation"
        class="main-form-scroll"
      >
        <el-form-item class="create-packet-line" prop="newPacketName">
          <label>{{ $t("packets.startOfPackageName") }}</label>
          <el-input v-model="packetCreation.newPacketName"></el-input>
        </el-form-item>
        <el-form-item class="create-packet-line" prop="appsForNewPacket">
          <label>{{ $t("packets.apps") + ":" }}</label>
          <el-select v-model="packetCreation.appsForNewPacket" multiple>
            <el-option
              v-for="(app, index) in getAppsArray"
              :key="index"
              :value="app.id"
              :label="app.alias ? app.name + ' (' + app.alias + ')' : app.name"
            ></el-option>
          </el-select>
          <el-button size="mini" @click="selectAllTypeApps('byt')">{{
            $t("packets.byt")
          }}</el-button>
          <el-button size="mini" @click="selectAllTypeApps('prom')">{{
            $t("packets.prom")
          }}</el-button>
          <el-button
            size="mini"
            @click="packetCreation.appsForNewPacket = []"
            >{{ $t("packets.clean") }}</el-button
          >
        </el-form-item>
        <el-form-item class="create-packet-line" prop="withDatabases">
          <el-radio v-model="packetCreation.withDatabases" label="0">{{
            $t("packets.withoutBindingToBases")
          }}</el-radio>
          <el-radio v-model="packetCreation.withDatabases" label="1">{{
            $t("packets.packageForEveryBase")
          }}</el-radio>
        </el-form-item>
        <el-form-item class="create-packet-line" prop="templateId">
          <label>{{ $t("packets.packageTemplate") }}</label>
          <el-select v-model="packetCreation.templateId" filterable>
            <el-option
              v-for="(template, index) in cronTemplates"
              :key="index"
              :value="template.id"
              :label="template.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="create-packet-line" prop="time">
          <label>{{ $t("packets.firstPackageStartTime") + ":" }}</label>
          <el-time-picker
            v-model="packetCreation.time"
            :picker-options="{ format: 'H:mm' }"
            format="H:mm"
            value-format="H:mm"
          ></el-time-picker>
        </el-form-item>
        <el-form-item class="create-packet-line" prop="interval">
          <label>{{ $t("packets.othersPackagesInterval") + ":" }} </label>
          <el-input-number
            v-model="packetCreation.interval"
            :min="1"
            :controls="false"
            size="mini"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <div class="bottom-buttons">
        <div></div>
        <div>
          <el-button
            class="button-cancel"
            type="plain"
            @click="cancelCreatePacket"
            >{{ $t("packets.cancel") }}</el-button
          >
          <el-button
            class="button-confirm"
            type="success"
            @click="okCreatePacket"
            >OK</el-button
          >
        </div>
      </div>
    </el-dialog>
    <el-dialog
      v-if="packetDeletionShow"
      visible
      :title="$t('packets.massPackageDelete')"
      :close-on-click-modal="false"
      @close="cancelDeletePackets"
    >
      <div>
        <div class="create-packet-line">
          <label>{{ $t("packets.showPackagesByTemplate") }}</label>
          <el-select
            v-model="deletePackets.templateId"
            filterable
            @change="findPacketsWithTemplate"
          >
            <el-option
              v-for="(template, index) in cronTemplates"
              :key="index"
              :value="template.name"
              :label="template.name"
            ></el-option>
          </el-select>
        </div>
        <div class="create-packet-line">
          <label>{{ $t("packets.packagesByThisTemplate") }}</label>
          <el-select
            v-model="deletePackets.selectedTemplatesArray"
            multiple
            :disabled="deletePackets.allTemplatePacketsArray.length === 0"
          >
            <el-option
              v-for="(packet, index) in deletePackets.allTemplatePacketsArray"
              :key="index"
              :value="packet.id"
              :label="packet.name"
            ></el-option>
          </el-select>
          <el-button
            size="mini"
            @click="selectAllPacketsToDelete"
            :disabled="deletePackets.allTemplatePacketsArray.length === 0"
            >{{ $t("packets.selectAll") }}</el-button
          >
          <el-button
            size="mini"
            @click="deletePackets.selectedTemplatesArray = []"
            :disabled="deletePackets.allTemplatePacketsArray.length === 0"
            >{{ $t("packets.clean") }}</el-button
          >
        </div>
        <div class="bottom-buttons">
          <div></div>
          <div>
            <el-button
              class="button-cancel"
              type="plain"
              @click="cancelDeletePackets"
              >{{ $t("packets.cancel") }}</el-button
            >
            <el-button
              class="button-confirm"
              type="success"
              @click="okDeletePackets"
              >OK</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>
    <div v-if="cronPackets && cronPackets.length >= 0">
      <div class="header cron">
        <div>
          <span v-if="!!selectedPacket" class="header-name">{{
            $t("packets.selected") + ":" + " " + selectedPacket.name
          }}</span>
        </div>
        <div class="header-buttons">
          <div class="cron-buttons-group">
            <el-dropdown>
              <el-button :disabled="!serverSelected"
                >{{ $t("packets.add")
                }}<i class="el-icon-arrow-down el-icon--right"></i
              ></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="createPacketClick">{{
                  $t("packets.addPackage")
                }}</el-dropdown-item>
                <el-dropdown-item @click.native="createMultiplePacketClick">{{
                  $t("packets.createSomePackages")
                }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown>
              <el-button :disabled="!selectedPacket"
                >{{ $t("packets.edit")
                }}<i class="el-icon-arrow-down el-icon--right"></i
              ></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="updPacket">{{
                  $t("packets.editPackageName")
                }}</el-dropdown-item>
                <el-dropdown-item
                  @click.native="createJobsClick"
                  :disabled="!selectedPacket"
                  >{{
                    $t("packets.editPackageStepsAndTasks")
                  }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown>
              <el-button :disabled="!selectedPacket"
                >{{ $t("packets.schedule")
                }}<i class="el-icon-arrow-down el-icon--right"></i
              ></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  @click.native="addSchedule"
                  :disabled="
                    !selectedPacket || selectedPacket.schedule.length > 0
                  "
                  >{{ $t("packets.addPackageSchedule") }}</el-dropdown-item
                >
                <el-dropdown-item
                  @click.native="editSchedule"
                  :disabled="
                    !selectedPacket || selectedPacket.schedule.length < 1
                  "
                  >{{ $t("packets.editPackageSchedule") }}</el-dropdown-item
                >
                <el-dropdown-item
                  @click.native="deleteSchedule"
                  :disabled="
                    !selectedPacket || selectedPacket.schedule.length < 1
                  "
                  >{{ $t("packets.deletePackageSchedule") }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>

            <el-dropdown>
              <el-button
                >{{ $t("packets.delete")
                }}<i class="el-icon-arrow-down el-icon--right"></i
              ></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  @click.native="deletePacket"
                  :disabled="!selectedPacket"
                  >{{ $t("packets.deletePackage") }}</el-dropdown-item
                >
                <el-dropdown-item @click.native="deleteMultiplePacketsClick">{{
                  $t("packets.deletePackageByTemplate")
                }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <div class="sort-line">
        <div></div>
        <el-dropdown trigger="click" class="view-dropdown">
          <el-button type="default" size="small">
            {{ $t("packets.packageSort") }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="sort('name')">{{
              $t("packets.name")
            }}</el-dropdown-item>
            <el-dropdown-item @click.native="sort('hour')">{{
              $t("packets.startTime")
            }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <div class="main-content list">
        <div v-if="cronPackets.length > 0">
          <div
            v-for="(packet, index) in cronPackets"
            class="list-item"
            :class="packetsClassArray[index]"
            :key="index"
          >
            <div
              class="main-list-element-label"
              :class="{ 'not-saved': packet.notSync }"
            >
              <div class="inside">
                <i
                  :class="arrowArray[index]"
                  class="arrow"
                  @click="arrowClicked(index)"
                  :key="packetKey"
                ></i>
                <span
                  class="packet-title"
                  @click="packetSelected(packet)"
                  @dblclick="arrowClicked(index)"
                >
                  <span class="name">{{ packet.name }}</span>
                  <!-- <span class="schedule">{{packet.schedule[0].parseTime}}</span> -->
                </span>
              </div>
              <span style="float: right" class="packet-short-info">
                <span
                  v-if="packet.schedule[0]"
                  :class="{ disabled: packet.schedule[0].disable === '1' }"
                  class="short-schedule"
                  >{{ packet.schedule[0].parseTime }}</span
                >
                <span
                  :class="{ white: !packet.notSync }"
                  style="padding-left: 10px"
                  >{{ $t("packets.templateEdited") }}</span
                >
              </span>
            </div>
            <div
              v-if="arrowArray[index] === 'el-icon-caret-bottom'"
              :key="packetKey"
            >
              <div class="main-sublist-name" v-if="packet.schedule.length > 0">
                {{ $t("packets.schedule") }}
              </div>
              <div v-if="packet.schedule.length > 0">
                <div
                  v-for="(sch, index) in packet.schedule"
                  :key="index"
                  class="main-list-task-element main-sublist-item"
                  :class="{ disabled: sch.disable === '1' }"
                >
                  {{ sch.parseTime }}
                </div>
              </div>
              <div class="main-sublist-name" v-if="packet.jobs.length > 0">
                {{ $t("packets.steps") }}
              </div>
              <div
                v-for="(job, index) in packet.jobs"
                :key="index"
                class="main-list-job-element main-sublist-item"
                :class="{
                  disabled: job.disable === '1',
                  'not-saved': job.notSync,
                }"
              >
                <span v-if="!!getAppsArray && getAppsArray.length > 0">
                  {{ job.tpName }}
                  <span v-if="job.notSync" style="float: right">{{
                    $t("packets.templateEdited")
                  }}</span>
                </span>
                <div
                  v-for="(task, index) in job.tasks"
                  :key="index"
                  class="main-list-task-element main-sublist-item"
                >
                  {{ task.caption }} &horbar; {{ task.params }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ScheduleForm from "./ScheduleForm";
import JobForms from "./JobForms";
import markUnsavedMixin from "./markUnsavedMixin";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      //   selectedPacket: null,
      packetCreateForm: false,
      packetsClassArray: [],
      packetKey: 0,
      arrowArray: [],
      createPacketShow: false,
      packetDeletionShow: false,
      deletePackets: {
        templateId: null,
        allTemplatePacketsArray: [],
        selectedTemplatesArray: [],
      },
      packetCreation: {
        newPacketName: null,
        appsForNewPacket: [],
        withDatabases: "0",
        templateId: null,
        time: "0:00",
        interval: 0,
      },
      packetCreationRules: {
        newPacketName: {
          required: true,
          message: this.$t("packets.enterPackageName"),
          trigger: "blur",
        },
        appsForNewPacket: {
          required: true,
          message: this.$t("packets.selectApps"),
          trigger: "change",
        },
        withDatabases: {
          required: true,
          message: this.$t("packets.selectPackageCreateMode"),
          trigger: "blur",
        },
        templateId: {
          required: true,
          message: this.$t("packets.selectPackageTemplate"),
          trigger: "change",
        },
        time: {
          required: true,
          message: this.$t("packets.enterStartTimeOfFirstPackage"),
          trigger: "blur",
        },
        interval: {
          required: true,
          message: this.$t("packets.enterPackageStartInterval"),
          trigger: "blur",
        },
      },
    };
  },
  methods: {
    packetSelected(packet) {
      //   this.selectedPacket = packet;
      this.$store.commit("setPacket", packet);
      //   this.selectedSchedule = null;
    },
    addSchedule() {
      this.$store.commit("setScheduleFlag", {
        action: "create",
        value: true,
      });
    },
    editSchedule() {
      //   this.cronExp = this.selectedSchedule.cron_time;
      this.$store.commit("setScheduleFlag", {
        action: "edit",
        value: true,
      });
    },
    deleteSchedule() {
      this.$confirm(
        `${this.$t("packets.thisActionDeleteScheduleOfPackage")}. ${this.$t(
          "packets.continue"
        )}?`,
        this.$t("packets.attention"),
        {
          confirmButtonText: "OK",
          cancelButtonText: this.$t("packets.cancellation"),
          type: "warning",
        }
      )
        .then(() => {
          //для удаления расписания из пакета с несколькими расписаниями -- нужно знать, какое id расписания я выбираю
          this.$store.commit("setLoading", true);
          return this.$store.dispatch(
            "delCronSchedule",
            this.selectedPacket.schedule[0].id
          );
        })
        .then(() => {
          this.$store.commit("setLoading", false);
          this.selectedPacket.schedule = [];
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
    createMultiplePacketClick() {
      this.createPacketShow = true;
    },
    createPacketClick() {
      this.$prompt(this.$t("packets.enterPackageName"), {
        confirmButtonText: this.$t("packets.accept"),
        cancelButtonText: this.$t("packets.cancellation"),
      })
        .then(({ value }) => {
          this.$store.commit("setLoading", true);
          return this.$store.dispatch("insCronPacket", value);
        })
        .then(() => {
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
    okCreatePacket() {
      // console.log("ЗАПРОС ДЛЯ СОЗДАНИЯ ПАКЕТА: ");
      const object = {
        cron: this.cron.id,
        template: this.packetCreation.templateId,
        sections: this.packetCreation.appsForNewPacket,
        databases: this.packetCreation.withDatabases,
        time: this.packetCreation.time.split(":"),
        interval: this.packetCreation.interval,
        prefix: this.packetCreation.newPacketName,
      };
      // console.log(this.packetCreation);
      // console.log(object);
      this.$refs["packetCreation"].validate((valid) => {
        if (valid) {
          // console.log("ALL RIGHT!");
          this.$store.commit("setLoading", true);
          this.$store
            .dispatch("createMultiplePackets", object)
            .then(() => {
              this.$store.commit("setLoading", false);
              this.cancelCreatePacket();
              if (object.databases === "0") {
                this.$message(
                  `${this.$t(
                    "packets.packageWereCreatedWithoutBases"
                  )}. ${this.$t("packets.fillBasesForEachPackage")}`
                );
              }
            })
            .catch((error) => {
              this.$store.commit("setLoading", false);
              console.error(error);
            });
        } else {
          this.$message.error(this.$t("packets.notAllRequiredFieldsSelected"));
        }
      });
    },
    cancelCreatePacket() {
      this.createPacketShow = false;
      this.packetCreation = {
        newPacketName: null,
        appsForNewPacket: [],
        withDatabases: "0",
        templateId: null,
        time: "0:00",
        interval: 0,
      };
    },
    selectAllTypeApps(typeAPI) {
      let apps = [];
      this.getAppsArray.forEach((app) => {
        if (app.typeAPI === typeAPI) apps.push(app.id);
      });
      this.packetCreation.appsForNewPacket = [];
      this.packetCreation.appsForNewPacket = [...apps];
    },
    deleteMultiplePacketsClick() {
      this.packetDeletionShow = true;
    },
    findPacketsWithTemplate(templateName) {
      let finalArray = [];
      this.cronPackets.forEach((packet) => {
        for (let job of packet.jobs) {
          if (job.tpName === templateName) {
            finalArray.push(packet);
            break;
          }
        }
      });
      this.deletePackets.allTemplatePacketsArray = [...finalArray];
    },
    cancelDeletePackets() {
      this.packetDeletionShow = false;
      this.deletePackets = {
        templateId: null,
        allTemplatePacketsArray: [],
        selectedTemplatesArray: [],
      };
    },
    okDeletePackets() {
      // console.log(this.deletePackets);
      if (this.deletePackets.selectedTemplatesArray.length === 0) {
        this.$message.error(this.$t("packets.noTemplateSelected"));
        return;
      }
      this.$store.commit("setLoading", true);
      this.$store
        .dispatch(
          "deleteMultiplePackets",
          this.deletePackets.selectedTemplatesArray
        )
        .then(() => {
          this.$store.commit("setLoading", false);
          this.cancelDeletePackets();
        })
        .catch((error) => {
          console.error(error);
          this.$store.commit("setLoading", false);
        });
    },
    selectAllPacketsToDelete() {
      // console.log(this.deletePackets);
      this.deletePackets.selectedTemplatesArray = [];
      this.deletePackets.allTemplatePacketsArray.forEach((packet) => {
        this.deletePackets.selectedTemplatesArray.push(packet.id);
      });
    },
    createJobsClick() {
      this.$store.commit("setJobsFlag", true);
    },
    updPacket() {
      this.$prompt(
        `${this.$t("packets.enterNewPackageName")} ${this.selectedPacket.name}`,
        {
          confirmButtonText: this.$t("packets.accept"),
          cancelButtonText: this.$t("packets.cancellation"),
          inputValue: this.selectedPacket.name,
        }
      )
        .then(({ value }) => {
          this.$store.commit("setLoading", true);
          return this.$store.dispatch("updCronPacket", {
            id: this.selectedPacket.id,
            name: value,
          });
        })
        .then(() => {
          this.markSelectedPacket();
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
    deletePacket() {
      // console.log(this.selectedPacket);
      this.$confirm(
        `${this.$t("packets.thisActionDeleteThisPackage")}: ${
          this.selectedPacket.name
        }. ${this.$t("packets.continue")}?`,
        this.$t("packets.attention"),
        {
          confirmButtonText: "OK",
          cancelButtonText: this.$t("packets.cancellation"),
          type: "warning",
        }
      )
        .then(() => {
          return this.$store.dispatch("delCronPacket", this.selectedPacket.id);
        })
        .then(() => {
          this.$store.commit("setPacket", null);
        })
        .catch(() => {});
    },
    sort(type) {
      this.$store.commit("sortPackets", type);
    },
    arrowClicked(index) {
      if (this.arrowArray[index] === "el-icon-caret-right") {
        // packet.show = false;
        this.arrowArray[index] = "el-icon-caret-bottom";
      } else {
        // packet.show = true;
        this.arrowArray[index] = "el-icon-caret-right";
      }
      this.packetKey++;
    },
    markSelectedPacket() {
      this.packetsClassArray = [];
      if (!!this.selectedPacket) {
        this.cronPackets.forEach((packet) => {
          if (packet.id === this.selectedPacket.id) {
            this.packetsClassArray.push("selected");
          } else {
            this.packetsClassArray.push("");
          }
        });
      } else {
        this.cronPackets.forEach((packet) => this.packetsClassArray.push(""));
      }
    },
  },
  mixins: [markUnsavedMixin],
  computed: {
    ...mapGetters([
      "serverSelected",
      "selectedPacket",
      "packetInfo",
      "getAppsArray",
      "cronPackets",
      "cronTemplates",
      "cron",
    ]),
  },
  created() {
    if (this.cronPackets && this.cronTemplates) this.markUnsavedJobs();
    this.markSelectedPacket();
  },
  components: {
    ScheduleForm,
    JobForms,
  },
  watch: {
    selectedPacket() {
      this.markSelectedPacket();
    },
    cronPackets() {
      if (this.cronPackets && this.cronTemplates) {
        this.markUnsavedJobs();
      }
    },
  },
};
</script>

<style scoped lang="css" src="./items.css">
</style>

<style scoped>
.el-dropdown .el-button {
  font-weight: 500 !important;
}
.sort-line {
  display: flex;
  justify-content: space-between;
}
.view-dropdown {
  margin-bottom: 10px;
}
.main-list-element-label {
  user-select: none;
  display: flex;
  justify-content: space-between;
}
.packet-title {
  display: flex;
  justify-content: space-between;
}
.inside {
  display: flex;
}
.white {
  color: transparent;
}
.create-packet-line {
  margin: 5px 0px;
}
.create-packet-line label {
  margin: 5px 15px 5px 0px;
}
</style>